import { FC, ReactNode } from 'react';
import ReactTooltip, { TooltipProps } from 'react-tooltip';
import './tooltipInfo.scss';

interface Props extends TooltipProps {
  id?: string;
  children?: ReactNode;
  place?: 'top' | 'right' | 'bottom' | 'left';
}

const TooltipInfo: FC<Props> = ({ id, children, place = 'top', ...props }) => {
  return (
    <div className='component-tooltip-info'>
      <ReactTooltip
        id={id}
        clickable
        effect='solid'
        place={place}
        type='info'
        delayShow={50}
        getContent={(content) =>
          content ? (
            <div className='component-tooltip-info__inner'>{content}</div>
          ) : undefined
        }
        {...props}>
        {children}
      </ReactTooltip>
    </div>
  );
};

export default TooltipInfo;
